import { API_ROUTE_ADMIN_REPORTS_CUSTOMERS } from '@/resources/api-routes'
import { get } from '@/util/auth'

type ReportCustomerOriginal = {
  id: number
  name: string
  countryId: number
}

export type GetReportCustomersParams = {
  statusInclude?: number[]
  statusExclude?: number[]
  isGlobal?: boolean
}

const IS_NEW_BACKEND_API = true

export const getReportCustomers = async (params?: GetReportCustomersParams) => {
  const queryParams = new URLSearchParams()

  if (params?.statusInclude && params.statusInclude.length > 0) {
    queryParams.append('statusInclude', params.statusInclude.join(','))
  }

  if (params?.statusExclude && params.statusExclude.length > 0) {
    queryParams.append('statusExclude', params.statusExclude.join(','))
  }

  if (params?.isGlobal !== undefined) {
    queryParams.append('isGlobal', params.isGlobal.toString())
  }

  const url = queryParams.toString()
    ? `${API_ROUTE_ADMIN_REPORTS_CUSTOMERS}?${queryParams.toString()}`
    : API_ROUTE_ADMIN_REPORTS_CUSTOMERS

  const reports = await get<ReportCustomerOriginal[]>(url, IS_NEW_BACKEND_API)

  return reports
}
